import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AppSideScroll from './AppSideScroll'
import AppCustomLink from './AppCustomLink';
import { spacing } from '../../lib/theme';
import { addOpacity, imagesCDNUrl } from '../../lib/utils';
import ReadingChallengeProgress from './ReadingChallengeProgress';

class ReadingChallenges extends Component {
    render() {
        const { readingChallenges } = this.props;
        console.dir(readingChallenges);
        return (
            <div style={{ marginBottom: '48px' }}>
                <AppSideScroll title={'Personalized Reading Challenges'}>
                    {
                        Object.values(readingChallenges).map((challengeMap, index) =>
                            <div key={index}>
                                {/* {index < genreMapsList.length && */}
                                <AppCustomLink href={`/challenge?id=${challengeMap.id}`} >
                                    <a>
                                        <div style={{
                                            background: `#${addOpacity(challengeMap['bgColor'], 0.1)}`,
                                            marginRight: `${spacing('lg')}`,
                                            borderRadius: '8px', width: '220px', height: '100px',
                                            padding: '1em 1.5em',
                                        }}>
                                            <div
                                                style={{
                                                    display: 'flex', alignItems: 'center'
                                                }}>
                                                <div style={{ width: '48px' }}>
                                                    <img style={{ maxWidth: '100%', borderRadius: '24px' }}
                                                        src={imagesCDNUrl +
                                                            '/readingChallenges/' +
                                                            challengeMap['image'] +
                                                            '.png'} />
                                                </div>
                                                <p style={{ marginBottom: '0', marginLeft: '12px' }}>{challengeMap['title']}</p>
                                            </div>
                                            <div style={{
                                                'padding': '0 0em',
                                                paddingTop: '8px',
                                                paddingBottom: '1em'
                                            }}>
                                                <ReadingChallengeProgress challengeId={challengeMap.id} showPercent={false} />
                                            </div>
                                        </div>
                                    </a>
                                </AppCustomLink>
                                {/* } */}
                                {/* {index === (genreMapsListFin.length - 1) &&
                                    <div onClick={this.openModal} style={{
                                        marginRight: `${spacing('lg')}`, cursor: 'pointer',
                                        background: 'hsla(223.9, 63.7%, 62.2%,1)', padding: '1em 1.5em', borderRadius: '8px', width: '220px', height: '88px'
                                    }}>
                                        <FontAwesomeIcon style={{ color: 'white', fontSize: '1.25em', marginBottom: '8px' }} icon='pen' />
                                        <p style={{ color: 'white', marginBottom: '0' }}>Edit Your Goals</p>
                                    </div>
                                } */}
                            </div>
                        )
                    }
                </AppSideScroll>
            </div>
        )
    }
}

ReadingChallenges.propTypes = {
    readingChallenges: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        readingChallenges: state.readingChallenges
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // fetchLatestSubscribedEpisodes: bindActionCreators(fetchLatestSubscribedEpisodes, dispatch),
    }
};

// export default withRedux(initStore, null, null)(Home);
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Home);

export default connect(mapStateToProps, mapDispatchToProps)(ReadingChallenges);